import React, { useState } from 'react'
import Sidebar from 'components/SideBar'
import TopBar from 'components/TopBar'
import { Page, Aside, Main } from './Layout.css'

const Layout = ({ children }) => {
  const { props } = children
  const [sidebarState, setSidebarState] = useState('closed')

  const topbarClick = value => {
    setSidebarState(value)
  }
  return (
    <Page>
      <TopBar sidebarState={sidebarState} onClick={topbarClick} />
      <Aside className={sidebarState}>
        <Sidebar onClick={() => setSidebarState('closed')} {...props} />
      </Aside>
      <Main>
        <main style={{ height: '100%' }}>{children}</main>
      </Main>
    </Page>
  )
}

export default Layout
